<template>
    <router-view />
</template>

<script>
export default {
    name: "Ozluk"
}
</script>

<style scoped></style>